<template>
  <div class="service-box">
    <div class="service-content">
      <div class="flex">
        <div>
          <img :src="imgUrl1" class="img" />
          <div class="label">{{ $t('carService.swiper1.label') }}</div>
          <div class="desc">{{ $t('carService.swiper1.desc') }}</div>
        </div>
        <div>
          <img :src="imgUrl2" class="img" />
          <div class="label">{{ $t('carService.swiper2.label') }}</div>
          <div class="desc">{{ $t('carService.swiper2.desc') }}</div>
        </div>
      </div>
      <div class="flex">
        <div>
          <img :src="imgUrl3" class="img" />
          <div class="label">{{ $t('carService.swiper3.label') }}</div>
          <div class="desc">{{ $t('carService.swiper4.desc') }}</div>
        </div>
        <div>
          <img :src="imgUrl4" class="img" />
          <div class="label">{{ $t('carService.swiper4.label') }}</div>
          <div class="desc">{{ $t('carService.swiper4.desc') }}</div>
        </div>
      </div>
      <div class="flex">
        <div>
          <img :src="imgUrl5" class="img" />
          <div class="label">{{ $t('carService.swiper6.label') }}</div>
          <div class="desc">{{ $t('carService.swiper6.desc') }}</div>
        </div>
        <div>
          <img :src="imgUrl6" class="img" />
          <div class="label">{{ $t('carService.swiper7.label') }}</div>
          <div class="desc">{{ $t('carService.swiper7.desc') }}</div>
        </div>
      </div>
    </div>
    <phone class="phone" />
  </div>
</template>
<script>
import Phone from '@/components/Common/Phone/phone.vue'

export default {
  components: { Phone },
  data() {
    return {
      imgUrl1: process.env.VUE_APP_FILE_URL + 'index/car/golf/service1.png',
      imgUrl2: process.env.VUE_APP_FILE_URL + 'index/car/golf/service2.png',
      imgUrl3: process.env.VUE_APP_FILE_URL + 'index/car/golf/service3.png',
      imgUrl4: process.env.VUE_APP_FILE_URL + 'index/car/golf/service4.png',
      imgUrl5: process.env.VUE_APP_FILE_URL + 'index/car/golf/service5.png',
      imgUrl6: process.env.VUE_APP_FILE_URL + 'index/car/golf/service6.png'
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style scoped lang="scss">
.service-box {
  background-color: $bg-color;
  padding-bottom: 157px;
  .service-content {
    padding-top: 104px;

    .flex {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 0 330px 56px;
      .img {
        width: 535px;
        height: 404px;
        border-radius: 28px;
      }
      .label {
        color: #f5f5f7;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 35px; /* 175% */
        letter-spacing: 0.196px;
        padding: 20px 0 10px 0;
      }
      .desc {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 112.5% */
        width: 500px;
      }
    }
  }
}
</style>
